"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useEffectEvent } from "react";
import { getEvent, useAnalytics } from "@/lib/analytics";
import { supportEmailOf, type PlatformScope } from "@/domain/scope/platform-scope";
import { BillingPendingPage } from "./billing-pending-page";
interface SetupPendingPageProps {
  readonly scope: PlatformScope;
}

/**
 * A member held by a pending staff-applied setup (spec underwriter/2026-10-17-001
 * R7 AC2): the billing-pending page with the product's own support address.
 * Emits `billing_setup_gate_redirected { scope, role: "member" }` once on mount
 * (D44; no PII).
 */
export function SetupPendingPage(t0) {
  const $ = _c(10);
  const {
    scope
  } = t0;
  const {
    track
  } = useAnalytics();
  let t1;
  if ($[0] !== scope || $[1] !== track) {
    t1 = () => {
      track(getEvent("billing-setup", "billing_setup_gate_redirected"), {
        scope,
        role: "member"
      });
    };
    $[0] = scope;
    $[1] = track;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onHeld = useEffectEvent(t1);
  let t2;
  if ($[3] !== onHeld) {
    t2 = () => {
      onHeld();
    };
    $[3] = onHeld;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== scope) {
    t4 = supportEmailOf(scope);
    $[6] = scope;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <BillingPendingPage supportEmail={t4} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}